export const refs = {
  get mainPage() {
    return document.querySelector('.main-page');
  },

  get mainScreen() {
    return document.querySelector('.main-screen');
  },

  get taskScreen() {
    return document.querySelector('.section-task');
  },

  get notesList() {
    return document.querySelector('.notes-list');
  },

  get createBtn() {
    return document.querySelector('.create-btn');
  },

  get listTask() {
    return document.querySelector('.list-task');
  },

  get formTask() {
    return document.querySelector('.controls-form');
  },

  get inputTask() {
    return document.querySelector('.task-input');
  },

  get removeBtn() {
    return document.querySelector('.remove-btn');
  },
  get saveBtn() {
    return document.querySelector('.save-btn');
  },
  get title() {
    return document.querySelector('.title');
  },
  get toMenuBtn() {
    return document.querySelector('.to-menu-btn');
  },

  themeBtn: document.querySelector('.theme-btn'),
};
